import React from 'react';
import './_import-empty-services.scss';

const ImportEmptyServices = () => (
  <div className="services-import__empty-services">
    <div>
      No services to import
    </div>
  </div>
)

ImportEmptyServices.propTypes = {

}

export default ImportEmptyServices;
